import React, { useState } from "react";
import { VerificationForm } from "../../../../widgets/VerificationForm";
import Verif from "../../../../shared/assets/icons/verif.svg";
import { useAppSelector } from "../../../../shared/store";
import { SIGNATURES } from "../../../../shared/consts";

export const VerificationNeedForm = () => {
  const offerData = useAppSelector((state) => state.payment.offer);
  const title = "Нужна верификация";
  const description =
    "По вашему платежу необходима верификация. Пожалуйста, загрузите в форму ниже чек об оплате и верный номер карты с которой делали перевод";

  return (
    <>
      {offerData && (
        <VerificationForm
          icon={Verif}
          title={title}
          description={description}
          orderNum={offerData ? String(offerData.humanId) : null}
          textBtn="Пройти верификацию"
          attachFile={true}
          offerData={offerData}
          cardNumber={true}
          inputSetting={{
            warn: offerData.canUploadVerificationImages
              ? "Необходимо загрузить корректный файл"
              : "Необходимо загрузить pdf файл",
            accept: offerData.canUploadVerificationImages
              ? "application/pdf, image/png, image/jpeg, image/jpg"
              : "application/pdf",
            signatures: offerData.canUploadVerificationImages
              ? [...SIGNATURES.pdf, ...SIGNATURES.jpg, ...SIGNATURES.png]
              : SIGNATURES.pdf,
            fileInputPlaceholder: offerData.canUploadVerificationImages
              ? "Выберите файл"
              : "Выберите pdf файл",
          }}
        />
      )}
    </>
  );
};
